/**
 * ホームページ フローティングナビゲーション
 * ページ最下部（フッター手前 100px）に到達したら非表示にする
 */
const homeFloatingNavigation = () => {
    const nav = document.querySelector('.pg-home-floating-navigation');
    if (!nav) return;

    const THRESHOLD = 100;

    const update = () => {
        const scrollBottom = window.scrollY + window.innerHeight;
        const pageHeight = document.documentElement.scrollHeight;
        nav.style.display = scrollBottom >= pageHeight - THRESHOLD ? 'none' : '';
    };

    window.addEventListener('scroll', update, { passive: true });
    update();
};

export default homeFloatingNavigation;
